export function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function removeLastSlash (string) {
  if (string.endsWith('/')) {
    return string.slice(0, -1);
  }

  return string;
}

export function countTrailingSpaces (string) {
  let count = 0;
  for (let i = string.length - 1; i >= 0; i--) {
    if (!/\s/.test(string[i])) break;
    count++;
  }
  return count;
}

export function countLeadingSpaces (string) {
  let count = 0;
  for (let i = 0; i < string.length; i++) {
    if (!/\s/.test(string[i])) break;
    count++;
  }
  return count;
}
